import React, { useContext, useEffect } from 'react';
import { Col, Image, Row, Stack } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import Loader from 'components/commom/Loader';
import EmptyScreen from 'assets/images/Dashboard/empty.svg';
import VedioIcon from 'assets/images/Dashboard/Video_Call_list.svg';
import DoctorIcon from 'assets/images/Dashboard/doctor-list.svg';
import Download from 'assets/images/Dashboard/dowload.svg';
import { getScannedImageCallAPI } from 'store/getScannedImage/action';
import { ClearTokenRedirectLogin } from 'utils/general';
import { useNavigate } from 'react-router-dom';
import CommonToast from 'components/commom/CommonToast';
import { LocaleContext } from 'routes/Router';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import ArrowRightIcon from 'assets/images/Dashboard/ArrowRight-request.svg';
import {
  basicDetailsValue,
  SCAN_DETAILS,
  SCAN_RESULT,
} from 'store/BasicDetailaAllValue/BasicDetailsValueAction';
import { scanResult } from 'routes/AppUrls';

const PatientDetailSkinAnalysis = () => {
  const { locale } = useContext(LocaleContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showToast } = CommonToast();

  const patientDetailValue = useSelector(
    (state) => state?.patientDetailReducer?.users?.data
  );

  const scanImageList = useSelector(
    (state) => state?.getScannedImageReducer?.users?.data
  );

  const loading = useSelector(
    (state) => state?.getScannedImageReducer?.loading
  );

  useEffect(() => {
    getSkinAnalysis();
  }, []);

  const getSkinAnalysis = () => {
    dispatch(
      getScannedImageCallAPI(`?user_id=${patientDetailValue?.id}`, {
        run: true,
        handleFunction: (res) => {},
        authorize: true,
        handleAuthorizeFunction: (res) => {
          ClearTokenRedirectLogin(navigate);
        },
        error: true,
        handleErrorFunction: (res) => {
          showToast(res?.message, 'error');
        },
      })
    );
  };

  const handleDetail = (data) => {
    dispatch(basicDetailsValue(SCAN_DETAILS, patientDetailValue));
    dispatch(basicDetailsValue(SCAN_RESULT, data));
    navigate(scanResult(locale));
  };

  return (
    <div>
      {loading ? (
        <Loader marginTop={'20vh'} />
      ) : (
        <div className="pt-20 mb-[50px]">
          <Row className="listCustomHeader m-0 p-0 flex items-center">
            <Col lg={3} md={6} sm={12}>
              <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                <FormattedMessage id="Image" />
              </p>
            </Col>
            <Col lg={3} md={6} sm={12}>
              <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                <FormattedMessage id="Scanning Date" />
              </p>
            </Col>
            <Col lg={4} md={6} sm={12}>
              <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                <FormattedMessage id="Status" />
              </p>
            </Col>
            <Col lg={2} md={6} sm={12}>
              <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                <FormattedMessage id="Actions" />
              </p>
            </Col>
          </Row>
          {scanImageList && scanImageList?.length > 0 ? (
            <Row className="bc-FFFFFF m-0 p-0">
              {scanImageList?.map((item, index) => {
                return (
                  <Row
                    className="m-0 p-0 flex items-center listAppointment"
                    key={index}
                  >
                    <Col lg={3} md={6} sm={12}>
                      <Zoom>
                        <Image
                          src={item?.original_image}
                          alt={'icon'}
                          style={{
                            height: '60px',
                            width: '50px',
                          }}
                        />
                      </Zoom>
                    </Col>
                    <Col lg={3} md={6} sm={12}>
                      <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176">
                        {moment(item?.scanning_date).format('DD MMM YYYY')}
                      </div>
                    </Col>
                    <Col lg={4} md={6} sm={12}>
                      <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176">
                        {item?.status}
                      </div>
                    </Col>
                    <Col lg={2} md={6} sm={12}>
                      <Stack
                        direction="horizontal"
                        gap={1}
                        className="items-center cursor-pointer"
                      >
                        <div
                          className="fs-14 fc-202224 lh-176 family_outfit_medium_500 underline underline-offset-4"
                          onClick={() => {
                            handleDetail(item);
                          }}
                        >
                          <FormattedMessage id="View Details" />
                        </div>
                        <Image
                          src={ArrowRightIcon}
                          alt="icon"
                          onClick={() => {
                            handleDetail(item);
                          }}
                        />
                      </Stack>
                    </Col>
                  </Row>
                );
              })}
            </Row>
          ) : (
            <div className="flex justify-center pt-120">
              <div>
                <Image src={EmptyScreen} alt="icon" />
                <div className="fs-20 fc-3C3C3C lh-2 family_outfit_medium_500 text-center	pt-30">
                  Nothing here yet
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default PatientDetailSkinAnalysis;
